export default "__VITE_ASSET__PlsADZB4__"